




































































































































































































































































































































































































































































































































































import {
  defineComponent,
  useRouter,
  useContext,
  ref,
  useFetch,
  computed,
  onMounted,
  watch,
} from "@nuxtjs/composition-api";
import { useUiState } from "~/composables";
import { useCartView } from "~/modules/checkout/composables/useCartView";
import { getUrlPathByCategoryId } from "~/modules/catalog/category/helpers";
import CategoryProductCard from "~/modules/catalog/category/components/views/CategoryProductCard.vue";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import { setSizeSwatch } from "~/modules/catalog/category/helpers";
import {
  getVariantImage,
  getVariantName,
  getUrlQuery,
  getBgColorValue,
  getColorLabel,
  getSizeLabel,
  getPrice,
  checkColorOption,
  checkSizeOption,
} from "~/modules/checkout/helpers";
import { getLabelColorBySku } from "~/helpers";
import NotificationModal from "~/components/NotificationModal.vue";
import EditItemCart from "~/modules/checkout/components/cartSidebar/EditItemCart.vue";
const CouponCartModal = () =>
  import(
    "~/modules/checkout/components/cartSidebar/coupon/CouponCartModal.vue"
  );
import FreeGiftListModal from "~/modules/checkout/components/cartSidebar/freeGift/FreeGiftListModal.vue";
import { useProduct, useSearchProducts } from "~/composables";
import { useCategoryStore } from "~/modules/catalog/category/stores/category";
import { useClevertapStore } from "~/stores/clevertap";
import { useConfigStore } from "~/stores/extensionApi";
import { useCartSuggestionsStore } from "~/stores/cartSuggestions";
import ProductLoadItem from "~/components/SkeletonLoader/ProductLoadItem.vue";
import { useRecommendationProduct } from "~/composables/useRecommendationProduct";
import { useCartStore } from "~/modules/checkout/stores/cart";

export default defineComponent({
  name: "CartSidebarNew",
  components: {
    NotificationModal,
    EditItemCart,
    CouponCartModal,
    FreeGiftListModal,
    CategoryProductCard,
    SkeletonLoader,
    ProductLoadItem,
  },
  setup() {
    const cartView = useCartView();
    const { isCartSidebarOpen, toggleCartSidebar } = useUiState();
    const router = useRouter();
    const { app } = useContext();
    const indexOptionsCart = ref(-1);
    const isRemoveConfirmVisible = ref(false);
    const isEditItemVisible = ref(false);
    const productToRemove = ref(null);
    const productToEdit = ref(null);
    const isSubtotal = ref(false);
    const isVisibleCoupon = ref(false);
    const { getProductListBySkusAndCateId } = useProduct();
    const categoryStore = useCategoryStore();
    const clevertapStore = useClevertapStore();
    const categoryTree = computed(() => categoryStore.categories);
    const storeConfig = useConfigStore();
    const { fetchProducts, loading: loadingProduct } = useSearchProducts();
    const loadingEditItem = ref(false);
    const cartSuggestionsStore = useCartSuggestionsStore();
    const { getRecommentProductCart, loading: loadingRecommentProducts } =
      useRecommendationProduct();
    const cartStore = useCartStore();
    const cartItemsState = computed(() => cartStore.cart?.items);

    const extendedCartCategoryId = computed(
      () => storeConfig.getExtendedProductCategory || ""
    );
    const extendedCartProducts = ref([]);

    const loadingExtendedProducts = computed(() =>
      cartSuggestionsStore.isCategoryLoading(extendedCartCategoryId.value)
    );

    // Wait for CleverTap to be available
    const waitForCleverTap = () => {
      return new Promise<string>((resolve) => {
        const checkCleverTap = () => {
          // Type-safe access with double assertion
          const win = window as any;
          if (
            typeof win !== "undefined" &&
            win.clevertap &&
            typeof win.clevertap.getCleverTapID === "function"
          ) {
            try {
              const id = win.clevertap.getCleverTapID();
              resolve(id || "");
            } catch (err) {
              console.error("Error getting CleverTap ID:", err);
              resolve("");
            }
          } else {
            setTimeout(checkCleverTap, 500);
          }
        };

        checkCleverTap();
      });
    };

    const fetchRecommentproductCart = async () => {
      const userId = await waitForCleverTap();
      if (!userId) {
        return;
      }
      if (!skuParents?.value || skuParents?.value?.length === 0) {
        extendedCartProducts.value = [];
        return;
      }
      const rs = await getRecommentProductCart(userId, skuParents.value);
      if (rs && rs.length > 0) {
        const params = {
          skus: rs,
          pageSize: rs.length || 12,
        };

        const { data } = await fetchProducts(params);
        extendedCartProducts.value = data || [];
      }
    };

    const fetchExtendedCartProducts = async () => {
      await fetchRecommentproductCart();

      if (extendedCartProducts.value.length > 0) return;
      if (!extendedCartCategoryId.value) return;

      if (
        cartSuggestionsStore.getProductsByCategoryId(
          extendedCartCategoryId.value
        ).length > 0 &&
        !cartSuggestionsStore.shouldRefetch(extendedCartCategoryId.value)
      ) {
        extendedCartProducts.value =
          cartSuggestionsStore.getProductsByCategoryId(
            extendedCartCategoryId.value
          );
        return;
      }

      cartSuggestionsStore.setLoading(extendedCartCategoryId.value, true);

      try {
        const params = {
          ids: [extendedCartCategoryId.value],
          pageSize: 6,
        };
        const { data } = await fetchProducts(params);
        const products = data || [];

        cartSuggestionsStore.setCategoryProducts(
          extendedCartCategoryId.value,
          products
        );

        extendedCartProducts.value = products;
      } catch (error) {
        console.error("Error fetching extended cart products:", error);
        extendedCartProducts.value = [];
      } finally {
        cartSuggestionsStore.setLoading(extendedCartCategoryId.value, false);
      }
    };

    watch(
      () => cartItemsState.value,
      () => {
        if (isCartSidebarOpen.value) {
          fetchExtendedCartProducts();
        }
      },
      { immediate: true, deep: true }
    );

    const goToCart = async () => {
      await router.push(app.localeRoute({ name: "cart" }));
    };

    const productQuantities = ref(new Map());

    const updateQuantity = (product, amount) => {
      try {
        const currentQty =
          productQuantities.value.get(product.product.uid) || product.quantity;
        const newQty = currentQty + amount;

        if (newQty <= 0) {
          removeItem(product);
          return;
        }

        if (
          product.dataInStock &&
          newQty > product.dataInStock.qty &&
          amount > 0
        ) {
          return;
        }

        productQuantities.value.set(product.product.uid, newQty);
        productQuantities.value = new Map(productQuantities.value);

        cartView.delayedUpdateItemQty({ product, quantity: newQty });
      } catch (error) {
        console.error("Error updateQuantity:", error);
        loadingEditItem.value = false;
      }
    };

    const getDisplayQuantity = (product) => {
      return productQuantities.value.has(product.product.uid)
        ? productQuantities.value.get(product.product.uid)
        : product.quantity;
    };

    const removeItem = (product) => {
      productToRemove.value = product;
      isRemoveConfirmVisible.value = true;
    };
    const loadingRemoveItem = ref(false);

    const confirmRemove = async () => {
      if (productToRemove.value) {
        try {
          isRemoveConfirmVisible.value = false;
          loadingRemoveItem.value = true;

          // Before removing the item, send tracking event to CleverTap
          trackProductRemoval(productToRemove.value);

          await cartView.removeItemAndSendNotification(productToRemove.value);
        } catch (error) {
          console.error("Error removing item:", error);
        } finally {
          productToRemove.value = null;
          loadingRemoveItem.value = false;
        }
      }
    };

    // Add a function to track product removal
    const trackProductRemoval = (productItem) => {
      try {
        const win = window as any;
        if (typeof win !== "undefined" && win.clevertap) {
          const product = productItem.product;
          const productParent = productItem.productParent;

          const parentSku =
            product.sku?.split("-").slice(0, -1).join("-") || product.sku;

          const color = productParent
            ? getColorLabel(
                productParent.configurable_children || [],
                product.sku,
                productParent.configurable_options_map || []
              )
            : "";

          const size = productParent
            ? getSizeLabel(
                productParent.configurable_children || [],
                product.sku,
                productParent.configurable_options_map || []
              )
            : "";

          const priceInfo = getPrice(productItem);

          const data = {
            product_id: product.sku?.split("-").slice(0, -1).join("-"),
            item_id: product.sku,
            item_name: productParent ? productParent.name : product.name,
            item_currency: "VND",
            item_price: priceInfo.special || priceInfo.regular,
            item_quantity: productItem.quantity,
            cart_id: app.$vsf.$magento.config.state.getCartId(),
            item_color_name: color,
            item_size: size,
            item_subtotal:
              (priceInfo.special || priceInfo.regular) * productItem.quantity,
          };

          // Send event to CleverTap with the properly formatted data
          clevertapStore.productRemovedFromCartCleverTap({
            clevertap: win.clevertap,
            data: data,
          });
        }
      } catch (error) {
        console.error("Error tracking product removal:", error);
      }
    };

    // Add a function to track cart view with required parameters
    const trackCartView = () => {
      try {
        const win = window as any;
        if (
          typeof win !== "undefined" &&
          win.clevertap &&
          cartView.products.value.length > 0
        ) {
          const cartItems = cartView.products.value;

          // Calculate total cart quantities and revenue
          let cartQuantity = 0;
          let cartRevenue = 0;

          // Prepare the cart view data object
          const cartViewData: Record<string, any> = {
            cart_id: app.$vsf.$magento.config.state.getCartId(),
            cart_quantity: 0,
            cart_revenue: 0,
            free_shipping_qualified: cartView.freeShipPrice.value <= 0,
            checkout_id: app.$vsf.$magento.config.state.getCartId(),
            action_placement: "Cart Sidebar",
            cart_subtotal: cartView.totals.value?.total || 0,
          };

          // Add each product's data with indexed properties
          cartItems.forEach((item, index) => {
            const productIndex = index + 1;
            const product = item.product;
            const productParent = item.productParent;
            const priceInfo = getPrice(item);
            const quantity = item.quantity;

            // Get parent SKU if available, fallback to direct SKU
            const parentSku =
              product.sku?.split("-").slice(0, -1).join("-") || product.sku;

            // Get color and size from parent variants if available
            const color = productParent
              ? getColorLabel(
                  productParent.configurable_children || [],
                  product.sku,
                  productParent.configurable_options_map || []
                )
              : "";

            const size = productParent
              ? getSizeLabel(
                  productParent.configurable_children || [],
                  product.sku,
                  productParent.configurable_options_map || []
                )
              : "";

            // Calculate individual and running totals
            const itemSubtotal =
              (priceInfo.special || priceInfo.regular) * quantity;
            cartQuantity += quantity;
            cartRevenue += itemSubtotal;

            // Add product-specific properties with index
            cartViewData[`product_id_${productIndex}`] = parentSku;
            cartViewData[`product_title_${productIndex}`] = productParent
              ? productParent.name
              : product.name;
            cartViewData[`product_price_${productIndex}`] =
              priceInfo.special || priceInfo.regular;
            cartViewData[`item_id_${productIndex}`] = product.sku;
            cartViewData[`item_quantity_${productIndex}`] = quantity;
            cartViewData[`item_color_name_${productIndex}`] = color;
            cartViewData[`item_size_${productIndex}`] = size;
            cartViewData[`item_subtotal_${productIndex}`] = itemSubtotal;

            // Add product suggestion information if available
          });

          // Add recommendation products data from extendedCartProducts if available
          if (
            extendedCartProducts.value &&
            extendedCartProducts.value.length > 0
          ) {
            extendedCartProducts.value.forEach((product, index) => {
              const suggestIndex = index + 1;
              cartViewData[`product_suggest_name_${suggestIndex}`] =
                product.name || "";
              cartViewData[`product_suggest_id_${suggestIndex}`] =
                product.sku || "";
            });
          }

          // Update total cart quantities and revenue
          cartViewData.cart_quantity = cartQuantity;
          cartViewData.cart_revenue = cartRevenue;

          // Send event to CleverTap
          clevertapStore.cartViewCleverTap({
            clevertap: win.clevertap,
            data: cartViewData,
          });
        }
      } catch (error) {
        console.error("Error tracking cart view:", error);
      }
    };

    // Watch for cart sidebar changes to trigger tracking
    watch(
      () => isCartSidebarOpen.value,
      (isOpen) => {
        if (isOpen) {
          setTimeout(() => {
            trackCartView();
          }, 500);
        }
      },
      { immediate: true }
    );

    watch(
      () => cartView.products.value,
      () => {
        if (isCartSidebarOpen.value) {
          trackCartView();
        }
      },
      { deep: true, immediate: true }
    );

    const cancelRemove = () => {
      isRemoveConfirmVisible.value = false;
      productToRemove.value = null;
    };

    const editItem = (product) => {
      productToEdit.value = product; // Set the product to edit
      isEditItemVisible.value = true;
    };

    const confirmEdit = async (newSku, uid, quantity) => {
      const oldSku = productToEdit.value.product.sku;
      if (newSku && uid && quantity) {
        if (oldSku === newSku) {
          cancelEdit();
          return;
        }

        try {
          isEditItemVisible.value = false;
          loadingEditItem.value = true;
          await cartView.updateItemCard(newSku, uid, quantity);
        } catch (error) {
          console.error("Error updating item:", error);
        } finally {
          loadingEditItem.value = false;
          isEditItemVisible.value = false;
          productToEdit.value = null; // Clear the product after editing
        }
      } else {
        productToEdit.value = null;
      }
    };

    const cancelEdit = () => {
      isEditItemVisible.value = false;
      productToEdit.value = null; // Clear the product when canceling
    };

    const openModalCoupon = async () => {
      if (isVisibleCoupon.value) {
        isVisibleCoupon.value = false;
        return;
      }
      isVisibleCoupon.value = true;
    };

    const errorCart = ref("");
    const checkExitCart = async () => {
      errorCart.value = await cartView.checkExitCart();
      if (!errorCart.value || errorCart.value === "") {
        toggleCartSidebar();
        cartView.goToCheckout();
      }
    };

    const skus = ref("");
    useFetch(async () => {
      const freeGiftRuleIds =
        cartView?.extensionAttributes.value?.free_gift_rule_ids || null;
      if (!freeGiftRuleIds) return;
      await cartView.loadFreeGifts(freeGiftRuleIds);
      await getTotalInCategoryCheck();
      if (cartView.freeGiftConfig.value) {
        if (
          cartView.freeGiftConfig.value?.skus &&
          cartView.freeGiftConfig.value?.skus !== ""
        ) {
          skus.value = cartView.freeGiftConfig.value.skus.toString();
          const { Maximum_qty_discount_is_applied } =
            cartView.freeGiftConfig.value;
          maximumQty.value = parseInt(Maximum_qty_discount_is_applied);
        }
      }

      isShowFreeGift();
    });

    const skuParents = computed((): string[] => {
      return cartItemsState.value
        ?.filter(
          (item) => item?.productParent && getPrice(item)?.priceValue > 0
        )
        .map((item) => item.productParent.sku);
    });

    // Đếm số lượng sản phẩm tại giỏ hàng nằm trong danh mục quà tặng: gift_category_check
    const getTotalInCategoryCheck = async () => {
      if (!cartView?.extensionAttributes?.value) {
        return 0;
      }

      const { gift_category_check } = cartView.extensionAttributes.value;
      if (!gift_category_check || gift_category_check?.toString() == "") {
        return 0;
      }

      // searh theo sku sản phẩm trong giỏ hàng và categoryId danh mục quà tặng
      // => tìm ra sản phẩm nào trong giỏ hàng nằm trong danh mục quà tặng
      const products = await getProductListBySkusAndCateId(
        skuParents.value,
        gift_category_check
      );

      let totalQuantity = 0;

      if (products && products?.items.length) {
        let varianSkus = [];
        products.items.forEach((item) => {
          if (item.variants && Array.isArray(item.variants)) {
            const itemVariantSkus = item.variants
              .map((variant) => variant.product?.sku)
              .filter(Boolean);
            varianSkus = [...varianSkus, ...itemVariantSkus];
          }
        });

        if (varianSkus && varianSkus.length) {
          cartView.products.value.forEach((item) => {
            if (getPrice(item).priceValue == 0) {
              return;
            }
            if (varianSkus.includes(item.product.sku)) {
              totalQuantity += item.quantity;
            }
          });
        }
      }

      totalInCategoryCheck.value = totalQuantity;
      return totalQuantity;
    };

    // free gift
    const openFreegiftModal = ref(false);
    const showFeeShip = ref(false);
    const cateBuyMoreId = ref("");
    const needMoneyForFreeShip = ref(0);

    const showFreeGift = ref(false);
    const needMoney = ref(0);

    const showFreeGiftNew = ref(false);
    const giftMessage = ref("");
    const needQty = ref(0);

    const maximumQty = ref(1);

    const totalInCategoryCheck = ref(0);

    let currentRule;
    const ampromoRuleId = ref(null);
    let nextRule;

    const isGiftCategory = ref(false);

    const isShowFreeGift = async () => {
      if (!cartView?.extensionAttributes?.value) {
        return;
      }
      const {
        free_gift_rule_ids,
        free_gift_total,
        category_buy_more,
        gift_category_check,
        gift_message,
        max_qty_check,
        min_qty_check,
        gift_config,
        total_freegift,
      } = cartView.extensionAttributes.value;

      cateBuyMoreId.value = category_buy_more;
      ampromoRuleId.value = free_gift_rule_ids;

      if (gift_category_check && gift_category_check?.toString() !== "") {
        isGiftCategory.value = true;
        showFreeGiftNew.value = true;
        if (
          totalInCategoryCheck.value >= min_qty_check &&
          totalInCategoryCheck.value < max_qty_check
        ) {
          needQty.value = max_qty_check - totalInCategoryCheck.value;
          if (gift_message) {
            giftMessage.value = gift_message.replace(
              "%s",
              needQty.value.toString()
            );
          }
        }

        if (totalInCategoryCheck.value < min_qty_check) {
          showFreeGiftNew.value = false;
        }

        if (totalInCategoryCheck.value >= max_qty_check) {
          showFreeGiftNew.value = true;
          needQty.value = 0;
          if (cartView.freeGiftConfig.value) {
            if (
              cartView.freeGiftConfig.value?.skus &&
              cartView.freeGiftConfig.value?.skus !== ""
            ) {
              skus.value = cartView.freeGiftConfig.value.skus.toString();
              const { Maximum_qty_discount_is_applied } =
                cartView.freeGiftConfig.value;
              let qtyConfig = parseInt(Maximum_qty_discount_is_applied);
              if (Maximum_qty_discount_is_applied) {
                maximumQty.value = qtyConfig;
                if (cartView.numberOfFreeGift.value >= maximumQty.value) {
                  showFreeGiftNew.value = true;
                }
              }
            } else {
              showFreeGiftNew.value = false;
            }
          }
        }
      } else {
        isGiftCategory.value = false;
        if (free_gift_total && total_freegift) {
          if (free_gift_rule_ids) {
            showFreeGift.value = true;
            if (free_gift_total === 0) {
              needMoney.value = 0;
            }
          }

          if (cartView.freeGiftConfig.value) {
            if (
              cartView.freeGiftConfig.value.skus &&
              cartView.freeGiftConfig.value.skus !== ""
            ) {
              skus.value = cartView.freeGiftConfig.value.skus.toString();

              if (gift_config && gift_config.length) {
                gift_config.forEach((rule) => {
                  if (total_freegift >= rule.total) {
                    currentRule = rule;
                    ampromoRuleId.value = rule.rule_id;
                  } else {
                    if (!nextRule) {
                      nextRule = rule;
                    }
                  }
                });

                if (currentRule) {
                  maximumQty.value = currentRule.max_qty;
                  needMoney.value = 0;
                } else if (nextRule) {
                  needMoney.value = nextRule.total - total_freegift;
                  maximumQty.value = nextRule.max_qty;
                }
                // if (cartView.numberOfFreeGift.value < maximumQty.value) {
                //   needMoney.value = 0;
                // } else {
                //   if (nextRule) {
                //     needMoney.value = nextRule.total - totalForFreegift;
                //   } else {
                //     needMoney.value = 0;
                //     showFreeGift.value = false;
                //   }
                // }
              } else {
                const { Maximum_qty_discount_is_applied } =
                  cartView.freeGiftConfig.value;
                let qtyConfig = parseInt(Maximum_qty_discount_is_applied);
                if (Maximum_qty_discount_is_applied) {
                  maximumQty.value = qtyConfig;
                  needQty.value = 0;
                  if (cartView.numberOfFreeGift.value >= maximumQty.value) {
                    showFreeGift.value = true;
                  }
                  if (free_gift_total > total_freegift) {
                    needMoney.value = free_gift_total - total_freegift;
                  } else {
                    needMoney.value = 0;
                  }
                }
              }
            } else {
              showFreeGift.value = false;
            }
          }
        }
      }
    };

    const convertToInteger = (value) => {
      return Math.round(parseFloat(value));
    };

    const openFreegift = () => {
      if (
        cartView.numberOfFreeGift.value >= convertToInteger(maximumQty.value) &&
        maximumQty.value !== 0
      ) {
        return;
      }
      openFreegiftModal.value = true;
    };

    watch(
      () => cartView.totals.value?.total,
      async (newValue) => {
        await getTotalInCategoryCheck();
        isShowFreeGift();
      },
      { immediate: true }
    );

    const cateBuyMore = () => {
      const { gift_category_check } = cartView.extensionAttributes.value;
      if (!gift_category_check || gift_category_check?.toString() == "") {
        return;
      }

      const url = getUrlPathByCategoryId(
        Number(gift_category_check),
        categoryTree.value
      );

      if (url) {
        toggleCartSidebar();
        return router.push(`/${url}`);
      }
    };

    const toggleItemActions = (index) => {
      indexOptionsCart.value = indexOptionsCart.value === index ? -1 : index;
      const minicartContent = document.querySelector(".minicart__content");
      if (minicartContent) {
        if (indexOptionsCart.value === index) {
          minicartContent.classList.add("open-action");
        } else {
          minicartContent.classList.remove("open-action");
        }
      }
    };

    return {
      ...cartView,
      isCartSidebarOpen,
      toggleCartSidebar,
      goToCart,
      getVariantImage,
      getVariantName,
      getUrlQuery,
      getBgColorValue,
      getColorLabel,
      getSizeLabel,
      updateQuantity,
      indexOptionsCart,
      removeItem,
      isRemoveConfirmVisible,
      confirmRemove,
      cancelRemove,
      editItem,
      isEditItemVisible,
      confirmEdit,
      cancelEdit,
      productToEdit,
      getPrice,
      isSubtotal,
      isVisibleCoupon,
      openModalCoupon,
      checkExitCart,
      errorCart,
      getDisplayQuantity,
      needMoney,
      showFreeGift,
      showFreeGiftNew,
      maximumQty,
      giftMessage,
      openFreegift,
      openFreegiftModal,
      convertToInteger,
      skus,
      needQty,
      cateBuyMore,
      ampromoRuleId,
      isGiftCategory,
      // Add new properties to be used in the template
      loadingExtendedProducts,
      extendedCartCategoryId,
      loadingProduct,
      checkColorOption,
      checkSizeOption,
      toggleItemActions,
      loadingRemoveItem,
      loadingEditItem,
      setSizeSwatch,
      extendedCartProducts,
      loadingRecommentProducts,
      getLabelColorBySku,
    };
  },
});
